import React, { Component } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './pages/login/login'
import Admin from './pages/admin/admin'

export default class App extends Component {

  constructor(props) {
    super(props)
    this.state = {
      coment: ""
    }
  }


  render() {
    return (
      <div>
        <Routes>
          <Route path="/" element={<div><Login /></div>} />
          <Route path="/admin/*" element={<div><Admin /></div>} />
          <Route path="/login" element={<div><Login /></div>} />
        </Routes>
      </div>
    )
  }
}
